// <pos-mascot-intro/> — 小掌櫃首次自我介紹卡（QA 付費條件 #3）
// see docs/QA_REPORT_20260707_minimax.md「小掌櫃 12 頁都出現卻從未解釋」
// 第一次登入顯示一次，「知道了」後永久隱藏（localStorage）。

const LS_KEY = 'tauke.mascot.introduced';

class PosMascotIntro extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
  }

  connectedCallback() {
    if (localStorage.getItem(LS_KEY) === '1') { this.remove(); return; }
    this.shadowRoot.innerHTML = `
      <style>
        :host { display: block; font-family: var(--font-sans); }
        .card { background: linear-gradient(135deg, rgba(232,88,12,.08), rgba(196,125,0,.06));
          border: 1px solid var(--brand-primary); border-radius: var(--r-lg);
          padding: var(--s-5); margin-bottom: var(--s-5); color: var(--fg-base); }
        h3 { margin: 0 0 var(--s-3); color: var(--brand-primary); font-size: 1.05rem; }
        ul { margin: 0 0 var(--s-4); padding-left: 0; list-style: none; display: grid; gap: var(--s-2); }
        li { font-size: .9rem; line-height: 1.6; }
        .ok { background: var(--brand-primary); color: var(--fg-on-brand, #fff);
          border: 0; border-radius: var(--r-md); padding: var(--s-2) var(--s-5);
          cursor: pointer; font-family: inherit; font-size: .95rem; }
      </style>
      <div class="card">
        <h3>👋 我是小掌櫃，你的 AI 店長助理</h3>
        <ul>
          <li>💬 <strong>有問題直接問我</strong>——「今天賣最好的是什麼？」「明天該進多少牛奶？」，在「小掌櫃」頁用聊天的就好</li>
          <li>☀️ <strong>每天早上 6 點</strong>，我會把昨天的營收、今天的訂位整理成晨報放在這裡</li>
          <li>📦 <strong>凌晨自動巡庫存</strong>——快過期、快賣完的食材，我會建議你怎麼推銷消化</li>
        </ul>
        <button class="ok">知道了，開始做生意 →</button>
      </div>
    `;
    this.shadowRoot.querySelector('.ok').addEventListener('click', () => {
      localStorage.setItem(LS_KEY, '1');
      this.remove();
    });
  }
}

customElements.define('pos-mascot-intro', PosMascotIntro);
